import { Modal } from "@flightstats/airframe-react";
import { modalContentStyle } from "../../js/components/modal/Modal";
import { IssueService } from "./issueService";
import React, { useState, ChangeEvent, FormEvent, useCallback, useEffect } from "react";
import { isUndefinedOrNullOrEmpty } from "../lib/filters";
import { BatchCommentProps } from './types';

const InputField: React.FC<{
  label: string;
  type: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  required?: boolean;
  maxLength?: number;
  rows?: number;
}> = ({ label, type, value, onChange, required = false, maxLength, rows }) => (
  <div className="row field-sep">
    <div className="col-md-3 fs-label fs-label-hxs hidden-sm hidden-xs">{label}</div>
    <div className="col-md-3 fs-label fs-label-xs visible-sm visible-xs">{label}</div>
    <div className="col-md-9">
      {type === "textarea" ? (
        <textarea
          className="text-area"
          value={value}
          onChange={onChange}
          maxLength={maxLength}
          required={required}
          rows={rows}
        ></textarea>
      ) : (
        <input type={type} value={value} onChange={onChange} required={required} />
      )}
      {maxLength && (
        <span>
          {maxLength - value.length} characters remaining ({maxLength} max)
        </span>
      )}
    </div>
  </div>
);

const BatchComment: React.FC<BatchCommentProps> = ({ issues, cancel, issuesUpdated }) => {
  const [fromAddress, setFromAddress] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [submitted, setSubmitted] = useState<boolean>(true);
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [comment, setComment] = useState<string>("");

  const ok = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      setSubmitted(true);
      IssueService.comment(issues, message, true, issuesUpdated);
      setIsOpen(false);
      cancel();
    },
    [issues, message, cancel]
  );

  const handleInputChange = useCallback(
    (setter: React.Dispatch<React.SetStateAction<string>>) =>
      (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setter(e.target.value);
      },
    []
  );

  useEffect(() => {
    if (!isUndefinedOrNullOrEmpty(subject) && !isUndefinedOrNullOrEmpty(message)) {
      setSubmitted(false);
    } else {
      setSubmitted(true);
    }
  }, [subject, message]);

  return (
    <Modal isOpen={isOpen} contentStyle={modalContentStyle}>
      <div className="issue-assign issue-resolution-modal modal-dialog modal-md">
        <form name="form" noValidate onSubmit={ok}>
          <div className="title">
            SEND MESSAGE
            <a onClick={cancel}>
              <i
                id="modalCancelled"
                className="cancel pull-right glyphicon icon-white glyphicon-remove"
              ></i>
            </a>
          </div>

          <div className="content">
            <div className="choices">
              <div className="row">
              <InputField
                  label="FROM (EMAIL)"
                  type="email"
                  value={fromAddress}
                  onChange={handleInputChange(setFromAddress)}
                />
                <br />
                (optional : override configured from address)
                <InputField
                  label="SUBJECT *"
                  type="text"
                  value={subject}
                  onChange={handleInputChange(setSubject)}
                  required
                />
                <InputField
                  label="MESSAGE *"
                  type="textarea"
                  value={message}
                  onChange={handleInputChange(setMessage)}
                  required
                  maxLength={160}
                  rows={3}
                />
                <div className="row field-sep">
                  <div className="col-md-3"></div>
                  <div className="col-md-9">* Required</div>
                </div>
              </div>
            </div>

            <div className="action">
              <button
                id="modalSubmitted"
                className="btn btn-default button-action"
                disabled={submitted}
                type="submit"
              >
                SEND
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default BatchComment;